import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import Styled, { css } from "styled-components";

import { getRandomInt, IntervalTimer } from "../../app/utils";

import { ITheme } from "../../interface";
import { useTheme } from "../../context/ThemeProvider";
import skillAndTools from "../../constant/skillAndTools";

import { screenSize, mediaMaxWidthValue } from "../../constant";
const { maxWidth } = screenSize;

const ContainerSkillTools = Styled.div`
    display: flex;
    z-index: 2;
    flex-direction: column;
    @media screen and (max-width: ${maxWidth.mediumTablet}) {
      height: 45vh;
    }
`;

const Slider = Styled.div`
    margin: 0 20px 0px 20px;
    left: -16.5%;
    height: 80%;
    width: 150%;
    position: relative;
    overflow: hidden;
    @media screen and (max-width: ${maxWidth.mediumTablet}) {
      position: absolute;
      margin: 0;
      left: 0;
      width: 100vw;
      height: 45vh;
    }
`;

const MoverWrapper = Styled.div<{
  $props: {
    delayShow: number;
  };
}>`
  position: relative;
  z-index: 0;
  ${({ $props }) => {
    const { delayShow } = $props;
    return css`
      transition: opacity 0.3s ease-in 0s, transform 0.3s ease-in 0s;
      opacity: 0;
      transform: translateY(-35vh);
      ${Slider}.show & {
        transition: opacity 0.3s ease-in ${delayShow}s,
          transform 0.3s ease-in ${delayShow}s;
        transform: translateY(0vh);
        opacity: 1;
        &:hover {
          z-index: 2;
        }
      }
    `;
  }}
`;

const Mover = Styled.div<{
  $props: {
    time: number;
    timeDelay: number;
    distance: number;
    right: number;
    keyframeName: string;
  };
}>`
    ${({ $props }) => {
      const { time, timeDelay, distance, right, keyframeName } = $props;

      return css`
        right: ${right}%;
        animation: ${keyframeName} ${time}s linear infinite;
        animation-delay: ${timeDelay}s;
        @keyframes ${keyframeName} {
          100% {
            transform: translateX(-${distance}%);
          }
        }
      `;
    }}
    position: absolute;
    width: 50px;
    z-index: 0;
    ${MoverWrapper} &:hover{
      z-index: 1;
      animation-play-state: paused;
      > div {
        width: auto;
        > span {
          width: 100%;
        }
        > p {
          display: block;
          max-width: 100%;
          opacity: 1
        }
      }
    }
`;
const STwrapper = Styled.div<{
  $props: {
    top: number;
  };
}>`
    ${({ $props }) => {
      const { top } = $props;
      return css`
        top: ${top}px;
      `;
    }}
    position: fixed;
    display: flex;
    align-items: center;
    margin: 5px;
    width: 67%;

    >p {
        width: auto;
        display: block;
        opacity: 0;
        max-width: 0%;
        transition:  max-width 2s ease-in, max-width 2s ease-out, opacity 0.1s ease-in, opacity 0.1s ease-out;
        overflow: hidden;
      }
`;
const STBox = Styled.span<{
  $props: {
    theme: ITheme;
    iconSize: number;
  };
}>`
    ${({ $props }) => {
      const { theme, iconSize } = $props;
      return css`
        width: ${iconSize}px;
        height: ${iconSize}px;
        background: ${theme.colors.primary};
        box-shadow: ${theme.colors.tertiary} 0px 1px 2px 0px,
          ${theme.colors.tertiary} 0px 2px 10px 2px;
        @media screen and (max-width: ${maxWidth.mediumPhoneV2}) {
          box-shadow: ${theme.colors.tertiary} 0px 1px 2px 0px,
            ${theme.colors.tertiary} 0px 1px 8px 1px;
        }
      `;
    }}
    position: absolute;
    transition: all 0.4s ease-in-out;
    padding: 0px;
    border-radius: 2px;
    z-index: 0;
`;
const STIcon = Styled.img<{
  $props: {
    theme: ITheme;
    fillIcon: boolean;
    iconSize: number;
  };
}>`
    ${({ $props }) => {
      const { fillIcon, theme, iconSize } = $props;
      return css`
        width: ${iconSize}px;
        height: ${iconSize}px;
        ${fillIcon
          ? `
          filter: ${theme.colors.cssFilterPrimary};
        `
          : ""}
      `;
    }}
    z-index: 1;
    pointer-events: none;
`;
const STName = Styled.p<{
  $props: {
    iconFontSize: number;
  };
}>`
    ${({ $props }) => {
      const { iconFontSize } = $props;
      return css`
        font-size: ${iconFontSize}px;
      `;
    }}
    padding: 0px 4px;
    white-space: nowrap;
    z-index: 1;
`;

const TransparentGradient = Styled.span<{
  $props: {
    position: "right" | "left";
    theme: ITheme;
  };
}>`
    ${({ $props }) => {
      const { theme, position } = $props;
      return css`
        @property --gradientColor {
          syntax: "<color>";
          initial-value: rgba(4, 13, 18, 1);
          inherits: false;
        }
        ${theme.name === "light"
          ? `
              --gradientColor: rgba(227,253,253,1);
            `
          : ""}
        background: var(--gradientColor);
        transition: --gradientColor 0.4s;

        ${(position === "left" ? `left: 2` : `right: 8`) + "%"};
        width: ${(position === "left" ? 20 : 27) + "%"};
        mask-image: linear-gradient(
          to ${position === "left" ? "right" : "left"},
          rgba(0, 0, 0, 1),
          rgba(0, 0, 0, 0)
        );
        -webkit-mask-image: linear-gradient(
          to ${position === "left" ? "right" : "left"},
          rgba(0, 0, 0, 1),
          rgba(0, 0, 0, 0)
        );
        @media screen and (max-width: ${maxWidth.meidumDesktopV1}) {
          ${(position === "left" ? `left: 2` : `right: 5`) + "%"};
        }
        @media screen and (max-width: ${maxWidth.smallDesktopV1}) {
          ${(position === "left" ? `left: 2` : `right: 8.5`) + "%"};
        }
        @media screen and (max-width: ${maxWidth.mediumTablet}) {
          height: 60vh;
          ${(position === "left" ? `left: 0` : `right: 0`) + "%"};
        }
      `;
    }}
    height: 100vh;
    top: 0;
    pointer-events: none;
    /* transition: all 0.3s ease-in-out 0s; */
    display: block;
    position: absolute;
    -webkit-mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    z-index: 3;
`;

type TSTData = {
  intervalTimer: IntervalTimer;
  data: {
    id: number;
    fillIcon: boolean;
    name: string;
    icon: string;
  };
  propOption: {
    keyframeName: string;
    place: number;
    time: number;
    timeDelay: number;
    distance: number;
    right: number;
    top: number;
    delayShow: number;
  };
};

function LandingSkillTool({ showContent }: { showContent: boolean }) {
  const { theme, oppositeTheme, browserType } = useTheme();
  const iconPerColumn = browserType === "chrome" ? 8 : 5;
  const screenWidth = window.screen.width;

  const [activateLandingSkillTool] = useState(
    browserType === "chrome"
      ? true
      : window.innerWidth <= mediaMaxWidthValue.mediumTablet
  );

  const sliderRef = useRef() as React.RefObject<HTMLDivElement>;
  const maxSliderHeight = 474.47;
  const maxSliderWidth = 1197.89;
  const sliderHeight =
    sliderRef.current?.getBoundingClientRect().height ?? maxSliderHeight;
  const sliderWidth =
    sliderRef.current?.getBoundingClientRect().width ?? maxSliderWidth;
  const maxIconSize = browserType === "safari" ? 32 : 36;
  const [iconSize, setIconSize] = useState(maxIconSize);
  const [iconFontSize, setIconFontSize] = useState(11);

  const [STOriginTime, setSTOriginTime] = useState(15);
  const [STOriginDistance, setSTOriginDistance] = useState(2500);

  const [defaultSTPropRight, setDefaultSTPropRight] = useState(-1);
  const [isReadyRenderST, setIsReadyRenderST] = useState(false);

  if (showContent) {
    sliderRef.current?.classList.add("show");
  } else {
    sliderRef.current?.classList.remove("show");
  }

  let STunUse = Array.from(Array(skillAndTools.length).keys());
  let STonUse: number[] = [];
  const generateRandomSTData = (excludeId: number) => {
    STunUse = _.without(STunUse, ...STonUse);
    const stIndex = getRandomInt(0, skillAndTools.length - 1, STonUse);
    STonUse = _.without(STonUse, excludeId);
    STonUse.push(stIndex);
    STunUse.push(excludeId);

    return skillAndTools[stIndex];
  };
  const updateSTProp = (pIndex: number, cIndex: number) => {
    setTransformedSkillAndTool((prevData: any) => {
      const newData = [...prevData] as TSTData[][];
      let defaultProp = newData[pIndex][cIndex].propOption;
      defaultProp.timeDelay = defaultProp.time;
      defaultProp.time = STOriginTime;
      defaultProp.distance = STOriginDistance;
      defaultProp.right = defaultSTPropRight;
      newData[pIndex][cIndex].propOption = defaultProp;

      const STdata = newData[pIndex][cIndex].data;
      const STId = STdata.id;
      newData[pIndex][cIndex].data = generateRandomSTData(STId);
      return newData;
    });
  };
  const updateSTIcon = (pIndex: number, cIndex: number) => {
    setTransformedSkillAndTool((prevData: any) => {
      const newData = [...prevData] as TSTData[][];

      const STdata = newData[pIndex][cIndex].data;
      const STId = STdata.id;
      newData[pIndex][cIndex].data = generateRandomSTData(STId);
      return newData;
    });
  };

  const [transformedSkillAndTool, setTransformedSkillAndTool] =
    useState<TSTData[][]>();
  useEffect(() => {
    setDefaultSTPropRight(() => {
      let result = -2;
      if (screenWidth <= mediaMaxWidthValue.mediumTablet) result = -5;
      if (screenWidth <= mediaMaxWidthValue.mediumPhoneV2) result = -10;
      if (screenWidth <= mediaMaxWidthValue.smallPhoneV1) result = -12.5;
      return result;
    });

    setIconSize(
      Number(
        _.round(sliderHeight * (maxIconSize / maxSliderHeight), 2).toFixed(2)
      )
    );
    setIconFontSize(
      Number(_.round(sliderHeight * (10 / maxSliderHeight), 2).toFixed(2))
    );
    setSTOriginTime(
      Number(_.round(sliderWidth * (15 / maxSliderWidth), 2).toFixed(2))
    );
    setSTOriginDistance(
      Number(_.round(sliderWidth * (2500 / maxSliderWidth), 2).toFixed(2))
    );
    const deadLineBottom = 420;
    const iconMaxBottom = Number(
      _.round((sliderHeight / maxSliderHeight) * deadLineBottom, 2).toFixed(2)
    );
    setTransformedSkillAndTool((prevValue) => {
      if (prevValue) {
        for (const chunk of prevValue) {
          for (const { intervalTimer } of chunk) {
            intervalTimer.stop();
          }
        }
      }
      let percentageSubValue = 0.35;
      if (screenWidth <= mediaMaxWidthValue.smallPhoneV2)
        percentageSubValue = 0.55;
      return (
        _.chunk(_.shuffle(skillAndTools), iconPerColumn)
          // _.chunk([skillAndTools[0], skillAndTools[31]], iconPerColumn)
          .slice(0, 3)
          .map((payload, pIndex) => {
            const excludePlace: number[] = [];
            return payload.map((data, cIndex) => {
              const place = getRandomInt(1, iconPerColumn, excludePlace);
              excludePlace.push(place);
              const widthRange = 8;
              STonUse.push(data.id);

              const percentage =
                pIndex * percentageSubValue +
                (place / iconPerColumn) * (40 / 100);
              const rightPercentage = widthRange * percentage;
              const right = (10 - rightPercentage) * 10;

              let time = STOriginTime;
              let distance = STOriginDistance;
              let speed = distance / time;
              distance = distance * percentage;
              time = distance / speed;
              const top = (cIndex / (iconPerColumn - 1)) * iconMaxBottom;
              const delayShow =
                1 -
                (1 / iconPerColumn) * (cIndex + 1) +
                (pIndex === 0 ? 0 : 0.1);

              const intervalTimer = new IntervalTimer((self) => {
                if (self.fired === 0) {
                  updateSTProp(pIndex, cIndex);
                  self.setInterval(STOriginTime * 1000);
                } else updateSTIcon(pIndex, cIndex);
              }, time * 1000);
              intervalTimer.start();

              return {
                intervalTimer,
                data,
                propOption: {
                  keyframeName: `moveSlideshow${pIndex}${cIndex}`,
                  place,
                  time,
                  timeDelay: 0,
                  distance,
                  right,
                  top,
                  delayShow,
                },
              };
            });
          })
      );
    });
    if (transformedSkillAndTool?.length) setIsReadyRenderST(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sliderHeight, sliderWidth]);

  const SkillTool = function () {
    return (
      <ContainerSkillTools>
        <TransparentGradient $props={{ position: "left", theme }} />
        <TransparentGradient $props={{ position: "right", theme }} />
        <Slider ref={sliderRef}>
          {!isReadyRenderST ? (
            <></>
          ) : (
            _.flatten(transformedSkillAndTool).map(
              ({ intervalTimer, data, propOption }, index) => {
                const { icon, fillIcon, name } = data;
                const { top, delayShow, ...animationOption } = propOption;
                return (
                  <MoverWrapper
                    key={`mover-${index}`}
                    $props={{ delayShow }}
                    onMouseEnter={() => intervalTimer.pause()}
                    onMouseLeave={() => intervalTimer.resume()}
                  >
                    <Mover $props={animationOption}>
                      <STwrapper $props={{ top }}>
                        <STBox $props={{ theme, iconSize }} />
                        <STIcon
                          $props={{ fillIcon, theme: oppositeTheme, iconSize }}
                          src={icon}
                          sizes="36"
                        />
                        <STName $props={{ iconFontSize }}>{name}</STName>
                      </STwrapper>
                    </Mover>
                  </MoverWrapper>
                );
              }
            )
          )}
        </Slider>
      </ContainerSkillTools>
    );
  };
  return activateLandingSkillTool ? SkillTool() : <div />;
}
export default LandingSkillTool;
